module.exports = global["$"] = require("-!.\\jquery.slim.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?$!./~/jquery/dist/jquery.slim.js-exposed
// module id = 111
// module chunks = 0 1 3 6 8